import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useGlobalContext } from "context/GlobalContext";
import { useSettingContext } from "context/SettingContext";
import usersAPI from "features/Setting/users/api/userApis";
import { useEffect } from "react";

const useCreateUser = ({ sortBy = "createdAt", sortOrder = "desc" }) => {
  const quaryClient = useQueryClient();
  const { setUserCreateMessage, search } = useSettingContext();

  return useMutation({
    mutationFn: usersAPI.addUserInfo,
    onSuccess: (data) => {
      console.log("data ===>", data);
      if (data?.data?.status === 200) {
        setUserCreateMessage(data?.data?.message || "User registered successfully");
        quaryClient.removeQueries(["users-data", { sortBy, sortOrder, search }]);
        // quaryClient.setQueryData(["users-data", { sortBy, sortOrder }], (oldQueryData) => {
        //   return {
        //     ...oldQueryData,
        //     data: {
        //       ...oldQueryData?.data,
        //       message: data?.data?.message,
        //       User: [...oldQueryData.data.User, data?.data?.user],
        //     },
        //   };
        // });
      } else {
        throw new Error(data?.data?.message || "An unexpected error occurred");
      }
    },
    onError: (error) => {
      throw new Error(error?.response?.data?.message || error.message || "An unexpected error occurred");
    },
  });
};

export default useCreateUser;
